import { User } from '../../user/ts';

export type UserLoginData = User;

export type LoginResponse = {
  token: string;
  user: UserLoginData;
  is_first_login: boolean;
};

export type LoginInput = {
  email: string;
  password: string;
};

export type ForgotPasswordInput = {
  email: string;
};

export type ChangePasswordInput = {
  newPassword: string;
  confirmPassword: string;
};

export enum CameFromType {
  A_FRIEND_OR_COLLEAGUE = 'A_FRIEND_OR_COLLEAGUE',
  SEARCH_ENGINE = 'SEARCH_ENGINE',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  OTHER = 'OTHER',
}

export enum CompanySizeType {
  FROM_1_TO_10_EMPLOYEES = 'FROM_1_TO_10_EMPLOYEES',
  FROM_11_TO_100_EMPLOYEES = 'FROM_11_TO_100_EMPLOYEES',
  FROM_101_TO_500_EMPLOYEES = 'FROM_101_TO_500_EMPLOYEES',
  MORE_THAN_500_EMPLOYEES = 'MORE_THAN_500_EMPLOYEES',
}

export type RegistrationInput = {
  first_name: string;
  last_name: string;
  company_name: string;
  email: string;
  phone_number: string;
  country_of_business: string;
  company_size: CompanySizeType;
  came_from: CameFromType[];
  language: string;
};

export type ConfirmRegistrationInput = {
  new_password1: string;
  new_password2: string;
};

export type UploadVerificationDocumentsInput = {
  personal_id: FileList | null;
  personal_id_filename: string;
  trade_license: FileList | null;
  trade_license_filename: string;
};

export enum RegistrationRequestStatusType {
  PENDING_VERIFICATION = 'PENDING_VERIFICATION',
  PENDING_REVIEW = 'PENDING_REVIEW',
  PENDING_ACTION = 'PENDING_ACTION',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}
